import script from "./ColorsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColorsList.vue?vue&type=script&setup=true&lang=ts"

import "./ColorsList.scss?vue&type=style&index=0&id=bebe5bea&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bebe5bea"]])

export default __exports__